<div class="row" *ngIf="user">
	<ul>
		<div class="p-3">
			<h4>Compte</h4>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Identifiant de connexion :</span>
				<span class="col-3">{{ user.login }}</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">E-mail :</span>
				<span class="col-12 col-lg-3">{{ user.email }}</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Rôle :</span>
				<span class="col-12 col-lg-3">{{ user.role.name }}</span>
			</div>
		</div>

		<div class="p-3">
			<h4>Informations personnelles</h4>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Prénom :</span>
				<span class="col-12 col-lg-3">{{ employee.firstName }}</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Nom :</span>
				<span class="col-12 col-lg-3">{{ employee.lastName }}</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Adresse :</span>
				<span class="col-12 col-lg-3">{{ employee.address.label }}</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Date de naissance :</span>
				<span class="col-12 col-lg-3" *ngIf="employee.birthDate">{{
					employee.birthDate
				}}</span>
				<span class="col-12 col-lg-3" *ngIf="!employee.birthDate"
					>Non spécifié(e)</span
				>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">N° téléphone :</span>
				<span class="col-12 col-lg-3" *ngIf="employee.phone">{{
					employee.phone
				}}</span>
				<span class="col-12 col-lg-3" *ngIf="!employee.phone"
					>Non spécifié(e)</span
				>
			</div>
		</div>

		<div class="p-3">
			<h4>Activité</h4>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Habilité(s) de soin</span>
				<span class="col-12 col-lg-3">
					<span *ngFor="let skill of employee.careSkills; let last = last">
						{{ skill.name }}<span *ngIf="!last"> | </span>
					</span>
				</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Spécialité(s)</span>
				<span class="col-12 col-lg-3" *ngIf="employee.specialties.length > 0">
					<span *ngFor="let spec of employee.specialties; let last = last">
						{{ spec.name }}<span *ngIf="!last"> | </span>
					</span>
				</span>
				<span class="col-12 col-lg-3" *ngIf="employee.specialties.length === 0">
					Non spécifié(e)
				</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Type :</span>
				<span class="col-12 col-lg-3">
					{{ employeeTypeString[employee.type] }}
				</span>
			</div>
			<div class="row p-2">
				<span class="col-12 col-lg-3 fw-bold">Centre de service(s) :</span>
				<span class="col">{{ employee.serviceCenter.address.label }}</span>
			</div>
		</div>
	</ul>
</div>
